import { Box, Button, Flex, Image } from "@qws-org/ui-kit";
import type { FC } from "react";

import {
  isExternalLink,
  isInternalLink,
  isTemplateUrl,
} from "~/core/utils/action.utils";
import { useDirectus } from "~/shared/utils/directus/useDirectus";

import type { FooterV4Props } from "../FooterV4";

export const FooterControls: FC<FooterV4Props> = ({
  isControlInactive,
  onCallAction,
  getUrl,
  data,
}) => {
  const { getDirectusImage } = useDirectus();
  return (
    data?.footer_controls && (
      <>
        <Box
          as="hr"
          height={1}
          width="100%"
          border={{ color: "border-subtle" }}
        />
        <Flex
          flexWrap="wrap"
          width={"100%"}
          justify="center"
          align="center"
          gap={4}
          m={{ mt: 32, mx: "auto" }}
          md={{ maxWidth: "100%", m: { mt: 40 } }}
        >
          {data?.footer_controls?.map((control) => {
            const controlAction = control?.footer_controls_id?.action;
            const action = controlAction?.action?.[0];
            const isInactive = controlAction
              ? isControlInactive(controlAction)
              : true;

            let href;

            if (isExternalLink(action?.item)) {
              if (isTemplateUrl(action?.item)) {
                href = undefined;
              } else {
                href = action.item.href ?? undefined;
              }
            }
            if (isInternalLink(action?.item)) {
              href = action.item.page ? getUrl(action.item.page) : undefined;
            }
            const handlePressButton = (): void => {
              if (controlAction) {
                onCallAction(controlAction);
              }
            };
            return (
              !isInactive && (
                <Button
                  href={href}
                  onPress={handlePressButton}
                  key={control?.id}
                  variant="secondary"
                  maxWidth={72}
                  maxHeight={40}
                  width="100%"
                  className="flex items-center"
                >
                  <Image
                    value={getDirectusImage(
                      control?.footer_controls_id?.icon?.id ?? "",
                      {
                        format: "webp",
                        width: 52,
                      },
                    )}
                  />
                </Button>
              )
            );
          })}
        </Flex>
      </>
    )
  );
};
